import React from 'react';
import { AiOutlineClockCircle } from 'react-icons/ai';
import { FaRobot } from 'react-icons/fa';
import { MdDevices } from 'react-icons/md';
import { RiQuestionnaireLine } from 'react-icons/ri';
import { TiDocumentText } from 'react-icons/ti';
import { VscPaintcan } from 'react-icons/vsc';
import './FAQSection.css';

function FAQSection() {

  const Card = ({ Icon, header, text, delay }) => (
    <div className="faq-card" style={{ animationDelay: `${delay}s` }}>
      <div className="faq-card-icon">
        <Icon size={36} color={'#377DFF'} />
      </div>
      <div className="faq-card-content">
        <div className="faq-card-header">{header}</div>
        <div className="faq-card-text">{text}</div>
      </div>
    </div>
  );

  const cards = [
    { header: 'Easily Accessible', icon: MdDevices, text: 'View our website on the device of your choice.' },
    { header: 'Personalised Offerings', icon: VscPaintcan, text: 'We personalise and customise our services based on your organization’s needs.' },
    { header: 'Document Traceability', icon: TiDocumentText, text: 'Keep complete control with simplified tracking and document history.' },
    { header: 'Automation', icon: FaRobot, text: 'Enjoy the perfect balance of automation and flexibility.' },
    { header: '24/7 Support', icon: RiQuestionnaireLine, text: 'Our customer service is available round-the-clock to assist you.' },
    { header: 'High Availability', icon: AiOutlineClockCircle, text: 'We maintain a 24/7 uptime target for seamless operations.' }
  ];

  return (
    <div className="faq-section-container">
      
      <div className="faq-title">FAQ</div>
      <div className="faq-description">What you should know</div>
      <div className="faq-subtext">
        A quick overview of the features and capabilities available to you
      </div>

      <div className="faq-grid">
        {cards.map((c, i) => (
          <Card
            key={i}
            Icon={c.icon}
            header={c.header}
            text={c.text}
            delay={0.1 * i}
          />
        ))}
      </div>
    </div>
  );
}

export default FAQSection;
